import { inject, Injectable } from '@angular/core';
import { PublicOfferFormService } from '../services/public-offer-form.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PublicOfferFormActions, PublicOfferFormResetActions } from '../actions/public-offer-form.actions';
import { catchError, exhaustMap, map, of, switchMap } from 'rxjs';
import { HttpError, HttpResponse } from '@shared/utils/models/http.model';
import {
  PublicOfferFormDetails,
  SendPublicOfferFormResponse,
} from '@features/public-offer-form/utils/models/public-offer-form.model';

@Injectable()
export class PublicOfferFormEffects {
  private readonly publicOfferFormService = inject(PublicOfferFormService);
  private readonly actions$ = inject(Actions);

  validateOfferForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicOfferFormActions.validateOfferForm, PublicOfferFormResetActions.cancelPublicOfferFormActions),
      switchMap((action) =>
        action.type === PublicOfferFormResetActions.cancelPublicOfferFormActions.type
          ? of(PublicOfferFormResetActions.cancelPublicOfferFormActionsSuccess())
          : this.publicOfferFormService.validateOfferForm(action.userId).pipe(
              map((response: HttpResponse<PublicOfferFormDetails>) =>
                PublicOfferFormActions.validateOfferFormSuccess({ data: response.message })
              ),
              catchError((error: HttpError) => of(PublicOfferFormActions.validateOfferFormFailure({ error })))
            )
      )
    );
  });

  sendOfferForm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicOfferFormActions.sendOfferForm),
      exhaustMap((action) =>
        this.publicOfferFormService.sendOfferForm(action.payload).pipe(
          map((response: HttpResponse<SendPublicOfferFormResponse>) =>
            PublicOfferFormActions.sendOfferFormSuccess({ data: response.message })
          ),
          catchError((error: HttpError) => of(PublicOfferFormActions.sendOfferFormFailure({ error })))
        )
      )
    );
  });
}
